// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"styles_infoRow__1ymty","text":"styles_text__1ht6e"};